/**
 * マイページ
 */
import Vue from "vue";
import * as types from "../../../mutation-types/backyard-types";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/search/my_pages`

const my_page = {
    namespaced: true,
    state: {
        content: [],
    },
    getters: {},
    actions: {
        fetch({ commit }) {

            return new Promise((resolve, _reject) => {
                Vue.$http.get(API_PATH).then(data => {
                    let content = data.content
                    commit(types.BACK_SEARCH_MY_PAGE, { content })
                    resolve(content)
                })
            })
        },
    },
    mutations: {
        [types.BACK_SEARCH_MY_PAGE] (state, { content }) {
            state.content = content
        },
    },
}

export default my_page